import React, { useState, useEffect } from 'react';
import AddAcceso from './AddAcceso';
import { useAccesos } from '../contexts/AccesosContext';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

function Accesos() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [accesos, setAccesos] = useState([]);
    const [menus, setMenus] = useState([]);
    const [editAcceso, setEditAcceso] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [accesoToDelete, setAccesoToDelete] = useState(null);

    const fetchAccesos = async () => {
        try {
            const response = await fetch(`${server}/sg_acceso`);
            const data = await response.json();
            setAccesos(data.$values);
        } catch (error) {
            console.error('Error al cargar los accesos:', error);
        }
    };

    const fetchMenus = async () => {
        try {
            const response = await fetch(`${server}/sg_menu`);
            const data = await response.json();
            setMenus(data.$values || []);
        } catch (error) {
            console.error('Error al cargar los menús:', error);
        }
    };

    const getMenuName = (idMenu) => {
        const menu = menus.find(m => m.id === idMenu);
        return menu ? menu.nombre_menu : '';
    };

    useEffect(() => {
        fetchAccesos();
        fetchMenus();
    }, []);

    const handleNewAcceso = () => {
        fetchAccesos();
        setEditAcceso(null);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleDeleteAcceso = async () => {
        if (accesoToDelete) {
            try {
                const response = await fetch(`${server}/sg_acceso/${accesoToDelete.id}`, { method: 'DELETE' });
                if (response.ok) {
                    fetchAccesos();
                    setDeleteDialogOpen(false);
                    alert('Acceso eliminado con éxito');
                } else {
                    alert('Error al eliminar el acceso');
                }
            } catch (error) {
                console.error('Error al eliminar el acceso:', error);
            }
        }
    };

    const handleOpenDialog = (acceso) => {
        setAccesoToDelete(acceso);
        setDeleteDialogOpen(true);
    };

    const filteredAccesos = accesos.filter(acceso => acceso.nombreacceso.toLowerCase().includes(searchQuery.toLowerCase()));


    return (
        <>
            <div className="right_col" role="main">
                <div className="x_content">

                    <br />
                    <AddAcceso onNewAcceso={handleNewAcceso} editAcceso={editAcceso} />
                    <div className="ln_solid" />

                    <h2>Accesos Existentes</h2>
                    
                        
                            <TextField
                                fullWidth
                                variant="outlined"
                                label="Buscar acceso"
                                value={searchQuery}
                                onChange={handleSearchChange}
                                style={{ marginBottom: '20px' }}
                            />
                            <div className="table-responsive">

                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Nombre Acceso</TableCell>
                                                <TableCell>Menu</TableCell>
                                                <TableCell>Estado</TableCell>
                                                <TableCell>Acciones</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {filteredAccesos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((acceso) => (
                                                <TableRow key={acceso.id}>
                                                    <TableCell>{acceso.nombreacceso}</TableCell>
                                                    <TableCell>{getMenuName(acceso.id_menu)}</TableCell>
                                                    <TableCell>{acceso.estado ? 'Activo' : 'Inactivo'}</TableCell>
                                                    <TableCell>
                                                        <Button onClick={() => setEditAcceso(acceso)} color="primary" disabled={!tienePermiso('Editar Acceso')}>Editar</Button>
                                                        <Button onClick={() => handleOpenDialog(acceso)} color="secondary" disabled={!tienePermiso('Eliminar Acceso')}>Eliminar</Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={filteredAccesos.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                                <Dialog
                                    open={deleteDialogOpen}
                                    onClose={() => setDeleteDialogOpen(false)}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle>{"Eliminar Acceso"}</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText>
                                            ¿Estás seguro de que quieres eliminar este acceso?
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={() => setDeleteDialogOpen(false)} color="primary">Cancelar</Button>
                                        <Button onClick={handleDeleteAcceso} color="primary" autoFocus>Eliminar</Button>
                                    </DialogActions>
                                </Dialog>
                            </div>
                        
                    
                </div>
            </div>
        </>
    )
}

export default Accesos